import React from 'react';
import PropTypes from 'prop-types';
import Card from '../../shared/Card';
import ImageUpload from '../../shared/ImageUpload';
import { compressImage } from '../../../utils/compressImage';

class ProfileSignature extends React.Component {
  constructor(props) {
    super(props);
    this.onDrop = this.onDrop.bind(this);
    this.onClear = this.onClear.bind(this);
  }

  static get propTypes() {
    return {
      signature: PropTypes.object,
      signatureDeleted: PropTypes.bool,
      signatureBase64: PropTypes.string,
      onLoadSignature: PropTypes.func,
      onClearSignature: PropTypes.func,
      showModalError: PropTypes.func,
    };
  }

  onDrop(files, rejectedFiles = []) {
    const file = files && files[0];
    const rejectedFile = rejectedFiles[0];

    if (rejectedFile) {
      this.props.showModalError();
      return;
    }

    if (file) {
      compressImage(file).then((compressedImage) => {
        compressedImage.preview = file.preview;
        this.props.onLoadSignature(compressedImage);
      });
    }
  }

  onClear() {
    this.props.onClearSignature();
  }

  render() {
    const { signature, signatureBase64, signatureDeleted } = this.props;
    return (
      <Card header="Signature">
        <ImageUpload
          base64={signatureDeleted ? [null] : [signatureBase64]}
          onDrop={this.onDrop}
          onClear={this.onClear}
          files={[signature]}
          showIcon={true}
        />
      </Card>
    );
  }
}

export default ProfileSignature;



// WEBPACK FOOTER //
// src/components/profile/ProfileSignature/index.jsx